module.exports = __webpack_public_path__ + "img/SCUBA_FINAL.65ea0a89.jpg";